import { render, staticRenderFns } from "./LandlordPropertyViewEdit.vue?vue&type=template&id=38178d76&scoped=true"
import script from "./LandlordPropertyViewEdit.vue?vue&type=script&lang=js"
export * from "./LandlordPropertyViewEdit.vue?vue&type=script&lang=js"
import style0 from "./LandlordPropertyViewEdit.vue?vue&type=style&index=0&id=38178d76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38178d76",
  null
  
)

export default component.exports